module.exports = __webpack_public_path__ + "static/fr-bc8ff156566c8a11ea480a5d15a57814.jpg";